import { createAction, props } from '@ngrx/store';
import { PenaltyFee } from './penalty-fee.model';

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record penaltyFee',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record penaltyFee success', 
    props<{ listData: PenaltyFee[] }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record penaltyFee failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record penaltyFee',
    props<{ updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record penaltyFee success',
    props<{ singleData: PenaltyFee }>()
);
export const updateRecordFailure = createAction(
    '[Data] Update record penaltyFee failure',
    props<{ error: string }>()
);

//DELETE A RECORD
export const deleteRecord = createAction(
    '[Data] Delete record penalty fee',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record penalty fee success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record penalty fee failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state penaltyFee',
);